import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ModuleConfigService as ConfigService } from 'src/app/shared/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  url: string;
  constructor(private httpClient: HttpClient,
    private configService: ConfigService
  ) {
    this.url = configService.rimApiUrl + configService.rimEndPoint + '/user';
  }
  public addUserProfile(): Observable<any> {
    return this.httpClient.post(this.url, '');
  }

}
